module.exports = __webpack_public_path__ + "img/maths.3e8b69d1.svg";